// React
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import style from '../ResultsVisualization.scss';

const animationDelay = 2000;

class ChoiceAndResult extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			percentage: props.percentage,
			showLabel: props.showLabel,
		};

		this.debouncedUpdate = _.debounce(() => { this.forceUpdate(); }, 500);
		this.animationDelayUpdate = _.debounce(() => { this.forceUpdate(); }, animationDelay);
	}

	componentDidMount() {
		window.addEventListener('resize', this.debouncedUpdate);
		this.debouncedUpdate();
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.percentage !== nextProps.percentage) {
			this.setState({
				percentage: nextProps.percentage,
			}, () => {
				if (this.props.showLabel === true) {
					this.animationDelayUpdate();
				}
			});
		}
		if (this.props.showLabel !== nextProps.showLabel) {
			// Timeout is here because in order to position the label the bar has to have stopped animating
			setTimeout(() => {
				this.setState({
					showLabel: nextProps.showLabel,
				});
			}, nextProps.showLabel === true ? animationDelay : 0);
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		// Only update if numVotes or percentage has changed
		if (
			(nextProps.percentage !== this.props.percentage) ||
			(nextProps.totalVotes !== this.props.totalVotes) ||
			(nextProps.numVotes !== this.props.numVotes) ||
			(nextState.showLabel !== this.state.showLabel)
		) {
			return true;
		}
		return false;
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.debouncedUpdate);
	}

	calculateBottomOffset() {
		const {
			image,
		} = this.props;

		let offset = -10; // standard gap

		// Subtract the height of the label from it
		if (this.labelContainer) {
			const labelContainerBox = this.labelContainer.getBoundingClientRect();
			offset -= labelContainerBox.height;
		}

		// Subtract the height of the bar from it
		if (image && this.barContainer && this.imageContainer) {
			const barContainerBox = this.barContainer.getBoundingClientRect();
			const imageContainerBox = this.imageContainer.getBoundingClientRect();

			if (barContainerBox.y > imageContainerBox.y) {
				offset -= (barContainerBox.y - imageContainerBox.y);
			}
		}

		return offset;
	}

	render() {
		const {
			image,
			correct = false,
			numVotes,
			totalVotes,
			theming,
		} = this.props;

		const { percentage } = this.state;

		const votePercentage = Math.round(numVotes / totalVotes * 100);


		const correctBarTheming = theming['styles.interactions.polls.studio.results.correct_bar'] || {};
		const wrapperTheming = theming['styles.interactions.polls.studio.results.bar_wrapper'] || {};
		const barTheming = theming['styles.interactions.polls.studio.results.bar'] || {};
		const choiceImageTheming = theming['styles.interactions.polls.studio.results.choice.image'] || {};
		const choiceLabelTheming = theming['styles.interactions.polls.studio.results.choice.label'] || {};
		const choiceLabelCaretTheming = theming['styles.interactions.polls.studio.results.choice.label.caret'] || {};

		const overrideStyles = (correct && this.state.showLabel) ? correctBarTheming : {};
		return (
			<div className={style.results__choiceresult__wrapper}>
				<div style={wrapperTheming} className={style.results__choiceresult__barwrapper}>
					<div ref={(node) => { this.barContainer = node; }} className={style.results__choiceresult__bar} style={{ transform: `translateY(${100 - parseFloat(percentage)}%`, ...barTheming, ...overrideStyles }}>
						<div ref={(node) => { this.labelContainer = node; }} className={style.results__choiceresult__label} style={{ top: this.calculateBottomOffset(), opacity: this.state.showLabel ? 1 : 0, ...choiceLabelTheming }}>
							<div className={style.results__choiceresult__box}>
								<span>{votePercentage ? `${votePercentage}%` : '0%'}</span>
								<span style={choiceLabelCaretTheming} className={style.results__choiceresult__caret} />
							</div>
						</div>
					</div>
				</div>
				{image && (
					<div
						ref={(node) => { this.imageContainer = node; }}
						className={style.results__choiceresult__imagewrapper}
						style={{ backgroundImage: `url(${image.url})`, ...choiceImageTheming }}
					/>
				)}
			</div>
		);
	}
}

ChoiceAndResult.propTypes = {
	image: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	correct: PropTypes.bool,
	numVotes: PropTypes.number.isRequired,
	totalVotes: PropTypes.number.isRequired,
	percentage: PropTypes.number.isRequired,
	showLabel: PropTypes.bool,
	theming: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};
ChoiceAndResult.defaultProps = {
	showLabel: true,
};

export default ChoiceAndResult;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/resultsvisualization/childcomponents/choiceandresult.js